import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface AuthState{
    authenticatedEmail: string|null;
}

const initialState: AuthState={
    authenticatedEmail: null,

}

const authSlice= createSlice({
    name:"auth",
    initialState,
    reducers:{
        setAuthenticatedEmail:(state, action:PayloadAction<string>)=>{
            state.authenticatedEmail = action.payload;
        },
    },
});

export const {setAuthenticatedEmail}= authSlice.actions;
export default authSlice.reducer;